module.exports = __webpack_public_path__ + "img/logo_bicikl_small.5be80df2.png";